<template>
  <div class="InsuranceTypeForm">
    <h2 class="gl_form-title">
      {{ t('rater.health.insurance-type.form-legend') }}
    </h2>

    <RadioButtonGroup
      id="type"
      :value="insuranceType"
      :options="insuranceOptions"
      v-model="insuranceType"
      :rules="[validationRules.radioRequired]"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
  import { useI18n } from 'vue-i18n'
  import type HealthConfigurations from '../../../../health/common/models/APP/HealthConfigurations'
  import type { HealthFormAnswersInterface } from '@/modules/common/common/models/APP/types'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  defineExpose({ triggerSubmit })

  interface PropsInterface {
    nextForm: String[]
    answers: HealthFormAnswersInterface
    configurations: HealthConfigurations
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})

  const { t } = useI18n()
  const { required } = useRules()

  const validationRules = {
    radioRequired: (value: string) => required(value, 'common.validations.option')
  }

  const insuranceOptions = ref(props.configurations.insuranceTypesOptions)
  const insuranceTypes = ref(props.configurations.insuranceTypes)
  const insuranceType = ref(
    props.answers.insuranceType ?? props.configurations.defaultInsuranceType
  )

  function getNextStep() {
    if (insuranceTypes.value.health.id === insuranceType.value) {
      return props.nextForm[0] //'CopayForm'
    }

    if (insuranceTypes.value.reimbursement.id === insuranceType.value) {
      return props.nextForm[1] //'StartDateForm'
    }

    return props.nextForm[2] //'AbroadOptionsForm'
  }

  function triggerSubmit() {
    const page = getNextStep()
    const answers: Partial<HealthFormAnswersInterface> = {
      insuranceType: insuranceType.value
    }

    if (answers.insuranceType !== props.answers.insuranceType) {
      answers.copayType = undefined
    }

    return { page, answers }
  }
</script>
